import React, { Component } from 'react';
import './Resources.css';

class Resources extends Component {
    state = {
        circleData: [],
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        let number = 0;
        let resourceInputs = this.props.resourceData.map(segmentItem => {
            if (this.props.groupId === segmentItem.groupId) {
                number += +segmentItem.value;
                return (
                    <div className='input-group'>
                        <label>{segmentItem.segmentName}</label>
                        <input value={segmentItem.value} onChange={(e) => this.props.resourceChanges(e, segmentItem)} type='number' />
                    </div>
                )
            }

        })

        return (
            <div className="resource-box">
                <p>Resource Allocation</p>
                {resourceInputs}
                <div className='resource-total'><strong>Resources Allocated:</strong>{number}%</div>
            </div>
        )
    }
}
export default (Resources);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/SegmentPriority/TabContent/Resources/Resources.jsx